export default __webpack_public_path__ + "static/media/29-460x460.229b1df6.jpeg";